class CachingProviderShim {
  constructor(provider, cache, prefix) {
    this._provider = provider;
    this._cache = cache;
    this._prefix = prefix || "";
    this._pending = {};
  }

  async get(key) {
    const keyStr = JSON.stringify(key);
    const fqk = `${this._prefix}.${keyStr}`;

    let promise = this._pending[fqk];
    if (promise) {
      await promise;
    }

    let value = this._cache.getObject(fqk);
    if (value !== undefined && value !== null) {
      return value;
    }

    promise = this._provider.get(key);
    this._pending[fqk] = promise;

    try {
      value = await promise;
      this._cache.setObject(fqk, value);
      return value;
    } finally {
      delete this._pending[fqk];
    }
  }
}

export default CachingProviderShim;
